import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { API_ROUTES_TRIP, API_TRIP_URL } from "../../config/apiConfig";
// import LoadingIndicator from '../components/LoadingIndicator';
import "./TripList.css";
import { useNavigate } from "react-router-dom";

type Trip = {
  userProfile: any;
  id: string;
  trip: {
    id: string;
    tripImage: string;
    tripName: string;
    region: string;
    startDate: string;
    endDate: string;
    numberOfTravellers: number;
  };
};

const TripList: React.FC = () => {
  const navigate = useNavigate();
  const [recommended, setRecommended] = useState<Trip[]>([]);
  const [popular, setPopular] = useState<Trip[]>([]);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [page, setPage] = useState<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(true);

  const fetchData = async () => {
    try {
      setIsLoading(true);

      // Use Promise.all to make both requests concurrently
      const [recommendedResponse, popularResponse] = await Promise.all([
        axios.get<Trip[]>(
          `${API_TRIP_URL}${API_ROUTES_TRIP.tripsWithProfile}?page=${page}`
        ),
        axios.get<Trip[]>(
          `${API_TRIP_URL}${API_ROUTES_TRIP.tripsWithProfile}?page=${page}`
        ),
      ]);

      // Extract data
      const recommendedData = recommendedResponse.data;
      const popularData = popularResponse.data;
      console.log("recommendedData", recommendedData);

      // Update state
      setRecommended((prev) =>
        page === 1 ? recommendedData : [...prev, ...recommendedData]
      );
      setPopular((prev) =>
        page === 1 ? popularData : [...prev, ...popularData]
      );

      // Check if there are more pages
      setHasMore(recommendedData.length > 0 && popularData.length > 0);
    } catch (error: unknown) {
      console.error("Unexpected Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  const handleLoadMore = () => {
    if (hasMore && !isLoading) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  const formatDate = (date: string) => {
    return dayjs(date).format("DD-MMM-YYYY");
  };

  const renderItem = useCallback(
    ({ item, isHorizontal }: { item: Trip; isHorizontal: boolean }) => {
      const isSelected = item.trip.id === selectedId;
      const itemStyle = isHorizontal ? "trip-card-horizontal" : "trip-card";

      return (
        <div
          className={`trip-card ${itemStyle} ${isSelected ? "selected" : ""}`}
          onClick={() => {
            setSelectedId(item.id);
            navigate(`/trip/${item.trip.id}`);
            // console.log(`Navigating to Trip ID: ${item.trip.id}`);
          }}
        >
          <img
            src={item.trip.tripImage}
            alt={item.trip.tripName}
            className="trip-card-image"
          />
          <div className="trip-card-content">
            <h3>
              {item.trip.tripName} : {item.trip.region}
            </h3>
            <p>
              {formatDate(item.trip.startDate)} to{" "}
              {formatDate(item.trip.endDate)}
            </p>
            <p> No. of Travellers: {item.trip.numberOfTravellers}</p>
            <p><img
                  src={item.userProfile.profilePic}
                  alt="Profile"
                  style={{
                    width: '30px', // Adjust size as needed
                    height: '30px',
                    borderRadius: '50%', // To make it circular
                    objectFit: 'cover'
                  }}
                /> Trip By: { item.userProfile.firstName}</p>
          </div>
        </div>
      );
    },
    [selectedId]
  );

  return (
    <div className="trip-list-container">
      {isLoading && page === 1 ? (
        <div className="loading-container">
          {/* <LoadingIndicator isLoading={isLoading} color="#1280f9" size="large" /> */}
        </div>
      ) : (
        <div className="trip-list">
          {popular.map((item) => (
            <div key={item.trip.id}>
              {renderItem({ item, isHorizontal: false })}
            </div>
          ))}
          {isLoading && (
            <div className="loading-container">
              {/* <LoadingIndicator isLoading={isLoading} color="#1280f9" size="large" /> */}
            </div>
          )}
          {/* {hasMore && !isLoading && (
            <button className="load-more-button" onClick={handleLoadMore}>
              Load More
            </button>
          )} */}
        </div>
      )}
    </div>
  );
};

export default TripList;
